module.exports = __webpack_public_path__ + "static/media/d2ru.8b26ccb0.pdf";